<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'professores' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Professor
        </h1>

        <div class="d-flex justify-space-around py-8">
          <v-toolbar style="height: 80px; border-radius: 10px" color="#BBDEFB">
            <v-row>
              <v-col class="pt-10 pb-5">
                <h4 class="mt-5">Padrão de acesso para o professor:</h4>
                <h5>Login: <strong>CPF</strong></h5>
                <h5 class="mb-6">Senha: <strong>Data de Nascimento</strong></h5>
              </v-col>
            </v-row>
          </v-toolbar>
        </div>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <!-- ===== DADOS PESSOAIS ===== -->
          <v-col cols="12">
            <h4>DADOS PESSOAIS</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider
              name="Nome Completo"
              :rules="{ required: true, max_chars: 255, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Nome Completo</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.nome"
                dense
                solo
                counter
                maxlength="255"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider
              name="Email"
              :rules="{ required: false, email: true, max_chars: 30, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Email</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.email"
                dense
                solo
                counter
                maxlength="30"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Telefone</e-label>
            <v-text-field v-mask="'(##) ####-####'" v-model="form.telefone" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Celular</e-label>
            <v-text-field v-mask="'(##) # ####-####'" v-model="form.celular" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider
              name="CPF"
              :rules="{ required: true, max_chars: 14, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Número do CPF</e-label>
              <v-text-field
                :error-messages="errors"
                v-mask="'###.###.###-##'"
                v-model="form.cpf"
                dense
                solo
                counter
                maxlength="14"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider
              name="INEP"
              :rules="{ required: false, max_chars: 8, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Identificação única (INEP)</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.codigo"
                dense
                solo
                counter
                maxlength="8"
                @keypress="apenasNumeros"
                @paste="filtrarColaNumerica"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider
              name="Data de nascimento"
              :rules="{ required: true, data_valida: true }"
              v-slot="{ errors }"
            >
              <e-label>Data de nascimento</e-label>
              <e-date-picker :error-messages="errors" v-model="form.dataNascimento" />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <ValidationProvider
              name="Filiação 1"
              :rules="{ required: false, max_chars: 255, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Filiação 1</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.filiacao1"
                dense
                solo
                counter
                maxlength="255"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <ValidationProvider
              name="Filiação 2"
              :rules="{ required: false, max_chars: 255, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Filiação 2</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.filiacao2"
                dense
                solo
                counter
                maxlength="255"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Sexo</e-label>
            <e-autocomplete
              :items="$constants.sexoList"
              :return-object="false"
              :item-value="(value) => value.id"
              :item-text="(value) => value.descricao"
              v-model="form.sexo_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Cor/Raça</e-label>
            <e-autocomplete
              :items="$constants.corOuRacaList"
              :return-object="false"
              v-model="form.cor_ou_raca"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Nacionalidade</e-label>
            <e-autocomplete
              :items="$constants.nacionalidadeList"
              :return-object="false"
              v-model="form.naturalidade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider
              name="País de nacionalidade"
              :rules="{ required: false, max_chars: 40, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>País de nacionalidade</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.nacionalidade"
                dense
                solo
                counter
                maxlength="40"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider
              name="Município de nascimento"
              :rules="{ required: false, max_chars: 40, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Município de nascimento</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.municipalidade"
                dense
                solo
                counter
                maxlength="40"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>UF de nascimento</e-label>
            <e-autocomplete
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.estadualidade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <!-- ===== PERFIL DE INCLUSÃO ===== -->
          <v-col cols="12">
            <h4>PERFIL DE INCLUSÃO</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <e-label
              >Profissional escolar com deficiência, transtorno do espectro autista ou altas
              habilidades/superdotação
            </e-label>
            <v-switch v-model="form.especial" style="width: fit-content"></v-switch>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Deficiência</e-label>
            <e-autocomplete
              clearable
              :items="$constants.tipoDeDeficienciaList"
              :return-object="false"
              v-model="form.tipos_de_deficiencia"
              label="Selecione uma opção"
              multiple
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Transtorno do espectro autista</e-label>
            <e-autocomplete
              clearable
              :items="$constants.tipoDeTranstornoDoEspectroAutistaList"
              :return-object="false"
              v-model="form.tipos_de_transtornos"
              label="Selecione uma opção"
              multiple
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Altas habilidades/superdotação</e-label>
            <e-autocomplete
              clearable
              :items="$constants.tipoDeAltasHabilidadesList"
              :return-object="false"
              v-model="form.tipos_de_altas_habilidades"
              label="Selecione uma opção"
              multiple
              dense
              solo
            />
          </v-col>

          <!-- ===== VÍNCULO TRABALHISTA ===== -->
          <v-col cols="12">
            <h4>VÍNCULO TRABALHISTA</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider
              name="Carga horária exercício"
              :rules="{ required: false, max_chars: 8, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Carga horária exercício</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.ch_exercicio"
                dense
                solo
                counter
                maxlength="8"
                @keypress="apenasNumeros"
                @paste="filtrarColaNumerica"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Vínculo</e-label>
            <e-autocomplete
              :items="$constants.vinculo"
              :return-object="false"
              :item-value="(value) => value.desc"
              :item-text="(value) => value.desc"
              v-model="form.vinculo"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider
              name="Matrícula"
              :rules="{ required: false, max_chars: 15, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Matrícula</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.matricula"
                dense
                solo
                counter
                maxlength="15"
              />
            </ValidationProvider>
          </v-col>

          <!-- ===== ÁREA RESIDENCIAL ===== -->
          <v-col cols="12">
            <h4>ÁREA RESIDENCIAL</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider
              name="País de residência"
              :rules="{ required: false, max_chars: 40, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>País de residência</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.pais_residencia"
                dense
                solo
                counter
                maxlength="40"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>CEP</e-label>
            <v-text-field v-mask="'#####-###'" v-model="form.cep" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label>UF</e-label>
            <e-autocomplete
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.uf_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider
              name="Município de residência"
              :rules="{ required: false, max_chars: 40, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Município de residência</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.municipio_residencia"
                dense
                solo
                counter
                maxlength="40"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="8">
            <ValidationProvider
              name="Endereço"
              :rules="{ required: false, max_chars: 255, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Endereço</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.endereco"
                dense
                solo
                counter
                maxlength="255"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider
              name="Bairro"
              :rules="{ required: false, max_chars: 150, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Bairro</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.bairro"
                dense
                solo
                counter
                maxlength="150"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Zona de Residência</e-label>
            <e-autocomplete
              :items="$constants.zonaResidenciaList"
              :return-object="false"
              v-model="form.zona_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <e-label>Localização diferenciada de residência</e-label>
            <e-autocomplete
              :items="$constants.localizacaoDiferenciadaDeResidenciaList"
              :return-object="false"
              v-model="form.zona_diferenciada_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <!-- ===== DOCUMENTAÇÃO ===== -->
          <v-col cols="12">
            <h4>DOCUMENTAÇÃO</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Org-Expedidor</e-label>
            <e-autocomplete
              :items="$constants.orgExpedidorList"
              :return-object="false"
              v-model="form.org_exp"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Estado Civil</e-label>
            <e-autocomplete
              :items="$constants.estadoCivilList"
              :return-object="false"
              :item-value="(item) => item.descricao"
              :item-text="(item) => item.descricao"
              v-model="form.estadoCivil"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider
              name="NIT ou PIS"
              :rules="{ required: false, max_chars: 11, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>NIT ou PIS</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.nit_pis"
                dense
                solo
                counter
                maxlength="11"
                @keypress="apenasNumeros"
                @paste="filtrarColaNumerica"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider
              name="PASEP"
              :rules="{ required: false, max_chars: 11, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>PASEP</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.pasep"
                dense
                solo
                counter
                maxlength="11"
                @keypress="apenasNumeros"
                @paste="filtrarColaNumerica"
              />
            </ValidationProvider>
          </v-col>

          <!-- ===== FORMAÇÃO ===== -->
          <v-col cols="12">
            <h4>FORMAÇÃO</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Escolaridade</e-label>
            <e-autocomplete
              :items="$constants.escolaridadeList"
              :return-object="false"
              v-model="form.escolaridade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Grau Acadêmico</e-label>
            <e-autocomplete
              :items="grausAcademicos"
              :return-object="false"
              :item-value="(item) => item.id"
              :item-text="(item) => item.descricao"
              v-model="form.grau_academico_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Ano de Conclusão</e-label>
            <v-text-field
              v-model="form.anoConclusao"
              dense
              solo
              maxlength="4"
              @keypress="apenasNumeros"
              @paste="filtrarColaNumerica"
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider
              name="Instituição"
              :rules="{ required: false, max_chars: 255, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Instituição</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.instituicao"
                dense
                solo
                counter
                maxlength="255"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider
              name="Outros Cursos"
              :rules="{ required: false, max_chars: 255, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>Outros Cursos</e-label>
              <v-textarea
                :error-messages="errors"
                v-model="form.outrosCursos"
                dense
                solo
                rows="3"
                counter
                maxlength="255"
              />
            </ValidationProvider>
          </v-col>

          <!-- Tipo de Professor e Franquias -->
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider name="Tipo de Professor" rules="required" v-slot="{ errors }">
              <e-label>Tipo de Professor:</e-label>
              <e-autocomplete
                :items="rolesDeProfessor"
                :return-object="false"
                v-model="form.role_id"
                :item-value="(role) => role.id"
                :item-text="(role) => role.name"
                label="Selecione uma opção"
                dense
                solo
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider name="Franquias do usuário" rules="required" v-slot="{ errors }">
              <e-label>Franquia(s) do usuário:</e-label>
              <e-autocomplete
                :items="franquiasList"
                :return-object="false"
                v-model="form.user.franquias_permitidas"
                :item-value="(franquia) => franquia.id"
                :item-text="(franquia) => franquia.descricao"
                :loading="carregandoFranquias"
                label="Selecione uma opção"
                dense
                multiple
                solo
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              block
              >Enviar Dados</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("Franquias", ["franquiasList", "carregandoFranquias"]),
  },
  async mounted() {
    await Promise.all([this.loadFormData(), this.loadData()]);
  },
  data() {
    return {
      submittingForm: false,
      form: { user: {} },
      grausAcademicos: [],
      rolesDeProfessor: [],
    };
  },
  watch: {
    form: {
      async handler(formValue) {
        try {
          const cepValue = this.$services.cepService.getCepInteiro(formValue.cep);
          if (cepValue) {
            const localizacao = await this.$services.cepService.buscarDadosDoCep(cepValue);
            this.form.municipio_residencia = localizacao.cidade;
            this.form.uf_residencia = localizacao.estado;
          }
        } catch (error) {
          this.$handleError("Erro ao buscar informações do CEP");
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("Franquias", ["loadFranquias"]),

    async submitForm() {
      this.form.especial = Boolean(this.form.especial);

      this.submittingForm = true;

      try {
        if (this.editing) {
          await this.$services.professoresService.atualizarProfessor(this.form);
          this.$toast.success("Professor(a) Atualizado(a) com sucesso ");
        } else {
          await this.$services.professoresService.criarProfessor(this.form);
          this.$toast.success("Professor(a) Criado(a) com sucesso");
        }
        this.$router.push({ name: "professores" });
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados");
        const [, roles, graus] = await Promise.all([
          this.loadFranquias(),
          this.$services.rolesService.buscarRolesDeProfessor(),
          this.$services.professoresService.grausAcademicos(),
        ]);

        this.rolesDeProfessor = roles;
        this.grausAcademicos = graus;
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async loadFormData() {
      if (!this.editing) return;

      const { professor_id } = this.$route.params;
      if (!professor_id) return;

      this.$loaderService.open("Carregando Professor(a)");
      try {
        const professor = await this.$services.professoresService.buscarProfessor(professor_id);
        this.form = {
          ...professor,
          ch_exercicio: professor.ch_exercicio != null ? String(professor.ch_exercicio) : null,
          user: {
            ...professor.user,
            franquias_permitidas: professor.user?.franquias_permitidas || [],
          },
        };
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    apenasNumeros(e) {
      if (!/[0-9]/.test(e.key)) e.preventDefault();
    },
    filtrarColaNumerica(e) {
      e.preventDefault();
      const texto = e.clipboardData.getData("text");
      const apenasNums = texto.replace(/[^0-9]/g, "");
      const input = e.target;

      const maxlength = parseInt(input.getAttribute("maxlength"), 10) || Infinity;
      const selectionLength = input.selectionEnd - input.selectionStart;
      const currentLength = input.value.length;
      const espacoDisponivel = maxlength - currentLength + selectionLength;

      const textoCortado = apenasNums.slice(0, espacoDisponivel);

      input.setRangeText(textoCortado, input.selectionStart, input.selectionEnd, "end");
      input.dispatchEvent(new Event("input"));
    },
  },
};
</script>

<style></style>
